<template>
    <h1>{{ $filters.i18n('nf.desc') }}</h1>
    <p>{{ $filters.i18n('nf.visit') }} <a href="/">{{ $filters.i18n('nf.home') }}</a> </p>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>